import { useLocation } from "react-router-dom"
import type { VerificationNoticeState } from "@/lib/use-verification-redirect"
import { Alert } from "./ui/alert"

// Explains why the signee was sent back to a verification step
const VerificationNotice = () => {
  const location = useLocation()
  const notice = (location.state as VerificationNoticeState | null)?.notice

  if (!notice) {
    return null
  }

  return (
    <div className="mx-auto mb-4 md:w-10/12 lg:w-8/12">
      <Alert variant="destructive">{notice}</Alert>
    </div>
  )
}

export { VerificationNotice }
